<template>
    <blogs-carousel-section
        class="recent-blog-posts-section-module"
        :slides="attributes.asyncData.posts"
        :title="$snippet('recent_blog_posts_title')"
        :button-link="$snippet('recent_blog_posts_button_link')"
        :button-text="$snippet('recent_blog_posts_button_text')"
    />
</template>

<script>
    import BlogsCarouselSection from '../../../organisms/BlogsCarouselSection/BlogsCarouselSection';

    export default {
        name: 'recent-blog-posts-section-module',

        components: { BlogsCarouselSection },

        props: {
            attributes: {
                type: Object,
                required: true,
                default: () => ({}),
            },
        },

        async asyncData({ store, attributes }) {
            const { posts } = await store.dispatch('blogs/fetchRecentBlogPosts', {
                exclude: parseInt(attributes.__page.id),
            });

            return {
                posts,
            };
        },
    };
</script>
